import { getGoodDetail, parseWaterDetail } from 'src/component/logic/tip-merchant/goods/detail';
import { GOODS_STATUS_MAP, GOODS_BUTTON_MAP } from 'src/project/user/views/award/config';

function parseGoodsDetail(info) {
  info.isExpired = info.status == GOODS_STATUS_MAP.IS_EXPIRED;
  info.isUsed = info.status === GOODS_STATUS_MAP.IS_USED;
  info.btnDesc = GOODS_BUTTON_MAP[info.status];
}


export function getMyAwardDetail(winningTime) {
  return new Promise((resolve, reject) => {
    getGoodDetail(winningTime, '/pvpesport.sgamenes.award.award/QueryGoodsDetailInfoV1')
      .then((info) => {
        parseGoodsDetail(info);
        resolve(info);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getBatchMyAwardDetail(list) {
  return new Promise((resolve, reject) => {
    // const promise = list.map(item => getMyAwardDetail(item.winningtime));
    const promise = list.map(item => parseWaterDetail(item.originWater));
    Promise.all(promise).then((res) => {
      resolve(res);
    })
      .catch((err) => {
        reject(err);
      });
  });
}
